import { destekApiFetch } from "../../destek/lib/destekApiClient";
const SESSION_KEY = "mbbe-portal-activity-session";
export function getPortalActivitySessionId() {
  let value = sessionStorage.getItem(SESSION_KEY);
  if (!value) {
    value =
      globalThis.crypto?.randomUUID?.() ??
      `${Date.now()}-${Math.random().toString(36).slice(2)}`;
    sessionStorage.setItem(SESSION_KEY, value);
  }
  return value;
}
export function clearPortalActivitySession() {
  sessionStorage.removeItem(SESSION_KEY);
}
export const recordPortalLogin = () =>
  destekApiFetch<{ ok: true }>("/portal/activity/session", {
    method: "POST",
    body: JSON.stringify({ sessionId: getPortalActivitySessionId() }),
  });
